import React, { FC, ButtonHTMLAttributes, ForwardedRef, ComponentType } from 'react';
import { WithTranslation } from 'react-i18next';
import { WithAnalytics } from 'ia-react-core/~/interfaces/WithAnalytics';

import { StyledButton, StyledIcon } from './StatusButton.styles';

export interface StatusButtonProps extends WithAnalytics, ButtonHTMLAttributes<HTMLButtonElement> {
  /** Status Icon. */
  Icon?: ComponentType;
  /** Accessible label. */
  label?: string;
  /** Icon color. */
  color?: string;
  /** @ignore */
  ref?: ForwardedRef<HTMLButtonElement>;
}

const StatusButton: FC<StatusButtonProps & WithTranslation> = React.forwardRef<HTMLButtonElement, StatusButtonProps & WithTranslation>(({ t, Icon, label, color, ...props }, ref) => (
  <StyledButton
    role="button"
    data-testid="StatusButton"
    aria-label={label}
    tabIndex={0}
    {...props}
    ref={ref}
  >
    <StyledIcon as={Icon} color={color} />
  </StyledButton>
));

StatusButton.displayName = 'StatusButton';

export default StatusButton;
